import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    ::selection {
      background: #fa4529;
      color: white;
    }
}
body {
    font-family: 'Martel Sans', sans-serif;
}

a {
  text-decoration: none;
  color: black;
}

`;

export default GlobalStyle;
